import axios from 'axios';

export const fetchRoles = () => axios.get('/api/get-permissions');

export const fetchSettings = () => axios.get('/api/get-settings');

export const changeRoles = (data) => axios.put('/api/permissions', data);
